window.ExternalTipProviderAPI = new (function () {
    const self = this;
    const _protected = BaseAPI.call(self);

    _protected.setApiUrl(publicConfiguration['ExternalTipProvider']);

    self.getTips = async (brandId, fromDate, toDate) => {
        const response = await _protected.request(`brands/${brandId}/tips?from_date=${fromDate}&to_date=${toDate}`, 'GET');

        if (response?.status === 200 && response?.data?.data) {
            return response.data.data;
        }

        throw response;
    };

    self.getGroupedTips = async (brandId, fromDate, toDate) => {
        const response = await _protected.request(`groups/${brandId}/tips?from_date=${fromDate}&to_date=${toDate}`, 'GET');

        if (response?.status === 200 && response?.data?.data) {
            return response.data.data;
        }

        throw response;
    }
});